import { render, staticRenderFns } from "./AlgemeneGegevens.vue?vue&type=template&id=8e87a076"
import script from "./AlgemeneGegevens.vue?vue&type=script&lang=js"
export * from "./AlgemeneGegevens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports